export const disableMuiButton = (bt) => {
    bt.disabled = true;
    bt.classList.add('Mui-disabled');
}

export const enableMuiButton = (bt) => {
    bt.disabled = false;
    bt.classList.remove('Mui-disabled');
}
